import classNames from "classnames";
import React from "react";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { UrlProvider } from "../../../../../../api/UrlProvider";
import withBottomNavigation from "../../../../../../hocs/withBottomNavigation";
import withTranslations from "../../../../../../hocs/withTranslations";
import SquaberButton from "../../../../common/SquaberButton";
import LandingTypography from "../../../components/LandingTypography";
import useIsDesktop from "../../../hooks/useIsDesktop";
import UpgradePlan from "./UpgradePlan";

const UpgradePlansWrapper = ({
  translate,
  locale,
  permissions,
  history,
  onSelect,
  setValue: setNavState
}) => {
  const isDesktop = useIsDesktop();

  return (
    <LandingTypography className={"plans landing-typography_dark"}>
      <div>
        <h1
          className={classNames("font-medium text-black mb-4 normal-case", {
            "text-2xl.1": isDesktop,
            "text-2xl": !isDesktop
          })}
        >
          {isDesktop
            ? translate("plans_heading_desktop")
            : translate("plans_heading")}
        </h1>
        <p className={"text-black text-base mb-6"}>
          {translate("plans_premium-modal_description")}
        </p>
        {Array.isArray(permissions) && permissions.length > 0 ? (
          <UpgradePlan
            permissions={permissions}
            onSelect={({ id }) => {
              history.push(
                UrlProvider.getUrl("fe.plans.availableInPlan", {
                  locale,
                  id
                })
              );
              setNavState("");
              onSelect?.();
            }}
          />
        ) : (
          <SquaberButton
            onClick={() => {
              history.push(
                UrlProvider.getUrl("fe.plans.mainPage", {
                  locale
                })
              );
              onSelect?.();
            }}
            color="primary"
          >
            {translate("See all plans")}
          </SquaberButton>
        )}
      </div>
    </LandingTypography>
  );
};

export default compose(
  withTranslations,
  withRouter,
  withBottomNavigation()
)(UpgradePlansWrapper);
